import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Divider, Stack } from "@mui/material";

import '../styles/ScanQRCode.css'
import QRCode from "react-qr-code";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../services/firebase";
import CustomButton from "../components/CustomButton";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";


const API_URL = process.env.REACT_APP_API_URL


const ActiveEvent = () => {
  const [user, setUser] = useState()
  const { userId } = useParams();
	const [showQRCode, setShowQRCode] = useState(true);
  const [activeEventURL, setActiveEventURL] = useState("")
	const [qrcodeDownloaded, setQRCodeDownloaded] = useState(false)

	const navigate = useNavigate()


	const handleShowQRCode = () => {
    setShowQRCode(prevState => !prevState);
  };

	const loadImage = (url) => {
		return new Promise((resolve, reject) => {
			const image = new Image();
			image.onload = () => resolve(image);
			image.onerror = (error) => reject(error);
			image.src = url;
		});
	};
	
	const generatePDF = async () => {
		if(!qrcodeDownloaded){
			setQRCodeDownloaded(true)
			try {
				const image = await loadImage('/QRCode-Template-2.png');
				const qrCodeElement = document.querySelector('#event-qr-code');
				if (!qrCodeElement) return;
				const qrCodeCanvas = await svgToCanvas(qrCodeElement);
				
				// Convert the loaded image and SVG canvas to data URLs
				const templateCanvas = document.createElement('canvas');
				const context = templateCanvas.getContext('2d');
				templateCanvas.width = image.width;
				templateCanvas.height = image.height;
				context.drawImage(image, 0, 0);
				const templateDataUrl = templateCanvas.toDataURL('image/png');
				const qrCodeDataUrl = qrCodeCanvas.toDataURL('image/png');

				const pdf = new jsPDF();
				pdf.addImage(templateDataUrl, 'PNG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());
				pdf.addImage(qrCodeDataUrl, 'PNG', 50, 105, 110, 110);
				pdf.save('QRCode.pdf');

		
			} catch (error) {
				console.error('Error generating PDF:', error);
			}
		}
	};

	const svgToCanvas = async(svgElement)  => {
		return new Promise((resolve, reject) => {
			const blob = new Blob([svgElement.outerHTML], { type: 'image/svg+xml' });
			const url = URL.createObjectURL(blob);
			const image = new Image();

			image.onload = () => {
				const canvas = document.createElement('canvas');
				const context = canvas.getContext('2d');
				canvas.width = image.width;
				canvas.height = image.height;
				context.drawImage(image, 0, 0);
				URL.revokeObjectURL(url);  // Clean up memory
				resolve(canvas);
			};

			image.onerror = (error) => {
				URL.revokeObjectURL(url);  // Clean up memory
				reject(error);
			};

			image.src = url;
		});
	}


	useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser)
				generatePDF()
      } else {
        setUser(currentUser)
        navigate('/Login')
      }
			try {
				const getUser = async () => {
					await fetch(`${API_URL}/firebase/get-user`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify({
							userId: userId,
						})
					}).then((res) => res.json())
					.then((res) => {
						fetch(`${API_URL}/firebase/get-user-active-events`, {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json'
							},
							body: JSON.stringify({
								userEmail: res.Email,
							})
						}).then((res) => res.json())
						.then((res) => {
							if(res[0]){
								setActiveEventURL(res[0].UID)
								navigate(`/Events/${res[0].UID}`)
								// if(!currentUser || currentUser.email !== res[0].Creator) {
								// 	if(res[0]){
								// 		navigate(`/Events/${res[0].UID}`)
								// 	} else {
								// 		navigate(`/`)
								// 	}
								// }
							}
						})
					})
				};
				getUser();
			} catch (e) {
				console.log(e)
			}
    })

    return () => unsubscribe()
  }, [user])


  return (
    <Box className="max_container" sx = {{ marginTop: 8 }}>
      <Divider sx={{ height: 10 }}/>
			<Stack className="items-center ">
				<button onClick={handleShowQRCode}>
					{showQRCode ? 'Hide QR Code' : 'Show QR Code'}
				</button>
				<div id="qr-code-container" className={`content-wrapper ${showQRCode ? 'show' : 'hide'}`}>
					<Box id="event-qr-code-box" className="text-center rounded-2xl p-5 mt-1 flex justify-center bg-white">
						<QRCode
							id="event-qr-code"
							sandbox="allow-same-origin"
							title="Event QR Code"
							className="w-[225px] h-[225px] mt-2"
							value={window.location.href}
						/>
					</Box>
					<Divider sx={{ height:'10px' }}/>
					{/* <CustomButton 
						myFunction={generatePDF}
						text={"Download QR-Code as PDF"}
					/> */}
				</div>
				<Divider sx={{ height: 10 }}/>
				{
					user && activeEventURL ? 
					<Stack className="items-center ">
						<CustomButton 
							myFunction={() => navigate(`/Events/${activeEventURL}`)}
							text={"Go to Active Event"}
						/>
					</Stack>
					:
					<div>
						<h3 className="uppercase center font-medium text-white mb-2">No Active Events</h3>
						Activate an event, then reload this page
					</div> 
				}
			</Stack>
      <Divider sx={{ height: 10 }}/>      
    </Box>
  );
};

export default ActiveEvent;
